/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../core/AppDispatcher'
import { List, Record } from 'immutable'
import { AppActionTypes, ErrorActionTypes } from '../action/AppActions'

const AppState = Record({
  isLoading: false,
  isError: false,
  messages: List([]),
  errorLevel: ''
})

class AppStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AppState()
  }

  reduce(state, action) {
    const payload = action.payload
    switch (action.type) {
      case AppActionTypes.loading:
        return new AppState({ isLoading: true })

      case AppActionTypes.loaded:
        return state.merge({ isLoading: false })

      case ErrorActionTypes.fatal:
        return state.merge({ isError: true, errorLevel: 'fatal' })

      case ErrorActionTypes.warn:
        return state.merge({ isError: true, errorLevel: 'warn' })

      case ErrorActionTypes.info:
        return state.merge({ isError: true, errorLevel: 'info' })

      default:
        return state
    }
  }
}

export default new AppStore()
